import axios from 'axios';
import FileDownload from 'js-file-download';
import { Dispatch } from 'redux';
import useRequest from '../../../../../hooks/useRequest';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { actionCreators } from '../../../../../state';
import i18n from 'i18next';

export const ri_property_management_excel_download = (eid: string) => {
    return async (dispatch: Dispatch<Action> | ((error: any) => void)) => {
        dispatch({
            type: ActionType.RI_PROPERTY_MANAGEMENT_EXCEL_DOWNLOAD_PENDING,
        });

        const { doRequest } = useRequest({
            url: `/api/ri/property-management/excel-dowload/${eid}`,
            method: 'get',
            body: {},
            onSuccess: (data) => {
                dispatch({
                    type: ActionType.RI_PROPERTY_MANAGEMENT_EXCEL_DOWNLOAD_SUCCESS,
                });
                dispatch(actionCreators.benit_central_ui_delete_all_errors());

                FileDownload(data, 'Report.xlsx');
            },
            onError: (error) => {
                dispatch(actionCreators.benit_central_ui_add_errors(error));
            },
        });

        doRequest({ responseType: 'blob' });
    };
};

export const ri_property_management_excel_download_popup_shown = () => {
    return async (dispatch: Dispatch<Action> | ((error: any) => void)) => {
        dispatch({
            type: ActionType.RI_PROPERTY_MANAGEMENT_EXCEL_DOWNLOAD_POPUP_SHOWN,
        });
    };
};
